import { render, staticRenderFns } from "./UnarchiveAssessmentButton.vue?vue&type=template&id=eb0b86fe&"
import script from "./UnarchiveAssessmentButton.vue?vue&type=script&lang=js&"
export * from "./UnarchiveAssessmentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports